module.exports = __webpack_public_path__ + "static/scale-model-of-coconut-kayak-tours-in-clearwater-florida-d44048e3cdc983a64caed6f30bdd3a44.png";